
export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: ['Main Office: (555) 123-4567', 'Emergency: (555) 987-6543'],
      description: 'Call us during business hours for immediate assistance'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: ['info@nextzensoccer.com', 'registration@nextzensoccer.com'],
      description: 'Send us an email and we\'ll respond within 24 hours'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Address',
      details: ['123 Soccer Academy Drive', 'Sportsville, CA 90210'],
      description: 'Visit our state-of-the-art training facility'
    },
    {
      icon: 'ri-time-line',
      title: 'Office Hours',
      details: ['Mon-Fri: 8:00 AM - 8:00 PM', 'Sat-Sun: 9:00 AM - 6:00 PM'],
      description: 'Our office is open to assist you'
    }
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', name: 'Facebook', url: '#' },
    { icon: 'ri-instagram-line', name: 'Instagram', url: '#' },
    { icon: 'ri-twitter-x-line', name: 'Twitter', url: '#' },
    { icon: 'ri-youtube-line', name: 'YouTube', url: '#' }
  ];

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Contact Information</h2>
          <p className="text-lg text-gray-600">Multiple ways to reach us and get the information you need</p>
        </div>

        <div className="space-y-6">
          {contactMethods.map((method, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${method.icon} text-2xl text-purple-600 w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{method.title}</h3>
                  <div className="mb-2">
                    {method.details.map((detail, detailIndex) => (
                      <p key={detailIndex} className="text-gray-900 font-medium">{detail}</p>
                    ))}
                  </div>
                  <p className="text-gray-600">{method.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Quick Actions</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <button className="bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Schedule Facility Tour
            </button>
            <button className="border-2 border-purple-600 text-purple-600 hover:bg-purple-600 hover:text-white py-3 px-6 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Download Brochure
            </button>
            <button className="bg-purple-600 hover:bg-purple-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Register for Program
            </button>
            <button className="border-2 border-purple-600 text-purple-600 hover:bg-purple-600 hover:text-white py-3 px-6 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Request Information
            </button>
          </div>
        </div>

        {/* Social Media */}
        <div className="mt-12 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Follow Us</h3>
          <div className="flex justify-center space-x-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                className="w-12 h-12 bg-gray-200 hover:bg-purple-500 text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
                aria-label={social.name}
              >
                <i className={`${social.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
              </a>
            ))}
          </div>
          <p className="text-gray-600 mt-4">Stay connected for updates, tips, and academy news</p>
        </div>

        {/* Emergency Contact */}
        <div className="mt-12 bg-red-50 border border-red-200 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <i className="ri-alarm-warning-line text-2xl text-red-600 mr-3 w-6 h-6 flex items-center justify-center"></i>
            <h3 className="text-xl font-bold text-red-800">Emergency Contact</h3>
          </div>
          <p className="text-red-700 mb-2">
            For urgent matters during training sessions or events:
          </p>
          <p className="text-red-800 font-bold text-lg">(555) 987-6543</p>
          <p className="text-red-600 text-sm mt-2">
            Available during all training hours and events
          </p>
        </div>
      </div>
    </section>
  );
}
